import React from 'react';

import { CardContent } from './CardContent';

interface Props extends React.ComponentProps<typeof CardContent> {}

export const CardFooter: React.FC<React.PropsWithChildren<Props>> = (props) => (
  <CardContent footer {...props} />
);
